<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
    <p-tabPanel header="COA">
        <div style="margin-bottom: 20px;">
            <!-- Checkbox -->
            <p-checkbox [binary]="true" [(ngModel)]="isChecked" label="Include Operator" (ngModelChange)="onCheckboxChange()"></p-checkbox>
            <!-- Radio Buttons -->

            <div style="margin-top: 10px;" *ngIf="isChecked">
                <div style="display: flex; align-items: center; margin-bottom: 10px; padding: 5px;">
                  <p-radioButton name="pick" pTooltip="Select colon (:)" [(ngModel)]="pickValue" [value]="true" class="radio-margin"></p-radioButton>
                  <h5 class="bold-text" style="margin-left: 5px; margin-bottom: 0;">:</h5> 
                </div>
                <div style="display: flex; align-items: center; padding: 5px;">
                  <p-radioButton name="pick" pTooltip="Select hyphen (-)" [(ngModel)]="pickValue" [value]="false" class="radio-margin"></p-radioButton>
                  <h5 class="bold-text" style="margin-left: 5px; margin-bottom: 0;">-</h5>   
                </div>
              </div>
        </div>
        <div class="p-grid">
       <div class="p-col-12">
        <p-table class="p-col-6" [value]="accountsArray?.controls" responsiveLayout="scroll" class="no-background">
            <ng-template pTemplate="body" let-account let-rowIndex="rowIndex">
                <tr [formGroup]="account">
                    <td class="no-padding">
                        <input type="text" class="shorter" onlyNumber  pInputText formControlName="displayAccountNumber"
                       >
                        - {{ account.get('name').value }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <div class="p-col-12 p-text-right">
                    <p-button (click)="saveCoa()" [disabled]="!isSaveEnabled()" label="Save"></p-button>
                </div>
            </ng-template>
        </p-table>
        </div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Chart of Accounts">
        <app-account></app-account>
    </p-tabPanel>
    <p-tabPanel header="Class">
        <app-class></app-class>
    </p-tabPanel>
    <p-tabPanel header="Pricing">
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
            <p-menu #configmenuFinanceSetup id="config_menu_setup" [model]="configMenuFinanceSetupItems" [popup]="true" appendTo="body">
            </p-menu>
            <span class="btnBars p-mr-0" (click)="configmenuFinanceSetup.toggle($event)">
          <i class="pi pi-bars"></i>
        </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>